export function SanitiseStatus(status: string) {
  switch (status) {
    case 'Archived':
      return 'Deleted';
    default:
      return status;
  }
}
